import { client } from '../../graphql/client';
import { SearchDevices } from "../../graphql/generated-queries/search-devices-queries";
import {getSelectedTenant} from "../../service/store";

export async function getDevices(input) {

  const variables = {
    ...input.filter,
    perPage: input.pagination.perPage,
    skip: (input.pagination.page - 1) * input.pagination.perPage,
    order: [
      {[input.sort.field]: input.sort.order}
    ]
  }

  const tenant = getSelectedTenant();
  const tenantId = tenant ? tenant.tenantId : null;

  try {
    const { data } = await client.query({ query: SearchDevices, variables: {...variables, tenantId } } );
    return { data: data.searchDevices.items, total: data.searchDevices.total };
  } catch (err) {
    console.error(err);
  }
}

